<template>
  <div class="popper_bg" v-if="isShow">
    <div class="popper_box">
      <div class="title">
        <div class="name">{{ title }}</div>
        <div class="delete" @click.stop.prevent='closeBg' v-if='isDelete'>
          <i class="iconfont iconguanbi"></i>
        </div>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: false
    }
  }, 

  props: {
    title: {
      default: '提示',
      type: String
    },
    isDelete: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    open() {
      this.isShow = true
    },

    closeBg() {
      this.isShow = false
      this.$emit('close')
    }
  }
}
</script>

<style lang='scss' scoped>
.popper_bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);

  .popper_box {
    position: absolute;
    left: 50%;
    top: 150px;
    margin: auto;
    width: 440px;
    transform: translateX(-50%);
    background-color: #fff;
    overflow: hidden;

    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 50px;
      font-size: 16px;
      font-weight: bold;
      color: #333;
      padding: 0 10px;
      background-color: #ebebeb;

      .iconguanbi {
        color: #999;
      }
    }

    .delete {
      cursor: pointer;
    }
  }
}
</style>